<template>
  <el-dialog title="预约服务" :visible.sync="formVisible" :close-on-click-modal="false" top="3vh" width="1000px">
    <div class="input-box">
      <el-input v-model="inputValue" placeholder="搜索订单号" prefix-icon="el-icon-search"></el-input>
      <el-button type="primary" size="small" @click="getAppointment">搜索</el-button>
    </div>
    <div class="content" :style="'height: ' + windowHeight + 'px; overflow-y: auto;'">
      <div class="cont-box">
        <div class="list-box">
          <div class="list" v-for="(item,index) in appointmentOptions" :key="index">
            <div class="order-no">
              订单号 <span class="no">{{item.orderNo}}</span> <i class="el-icon-copy-document" style="cursor: pointer;" @click="handleCopy(item)"></i>
              <div class="icon-rig"><em :class="{'red':item.status === 10,'blue': item.status === 20}">{{item.status === 10?'待分配':(item.status === 20?'待服务':(item.status === 30?'待评论':(item.status === 40?'已完成':'已取消')))}}</em></div>

            </div>
            <div class="user">{{item.technicianInfoRealName}} {{item.technicianInfoMobile}}</div>
            <div class="order-info">
              <div>
                <span>预约人：</span>
                <p>{{item.customerName}}</p>
              </div>
              <div>
                <span>预约服务：</span>
                <p>{{item.serviceItems}}</p>
              </div>
              <div>
                <span>时间：</span>
                <p :class="{'yellow':!item.appoTime}">{{item.appoTime}}</p>
              </div>
              <div>
                <span>地址：</span>
                <p :class="{'gray':!item.address}">{{item.address || '线上预约，暂无地址'}}</p>
              </div>
              <div>
                <span>备注：</span>
                <p :class="{'gray':!item.message}">{{item.message || '无'}}</p>
              </div>
            </div>
            <div class="send fr"><el-button type="primary" size="small" @click="handleSend(item)">发送</el-button></div>
          </div>
        </div>
      </div>
      <el-empty description="暂无数据" v-if="!appointmentOptions.length"></el-empty>
    </div>
  </el-dialog>
</template>

<script>
import technicianServiceOrderApi from '@/api/technical/technicianServiceOrder'

export default {
  props: ['currentUser'],
  data() {
    return {
      formVisible: false,
      appointmentOptions: [],
      inputValue: ''
    }
  },
  created() {
    const windowHeight =
      window.innerHeight ||
      document.documentElement.clientHeight ||
      document.body.clientHeight;
    this.windowHeight = windowHeight - 200;
  },
  methods: {
    handleClick() {

    },
    getAppointment() {
      technicianServiceOrderApi.fetchForList({ orderNo: this.inputValue, customerId: this.currentUser.toUserInfoId }).then(({ data }) => {
        let { list } = data;
        list.forEach(item => {
          item.appoTime = ''
          if (item.startTime && item.endTime) {
            item.appoTime = `${item.startTime.substr(0, 16)}-${item.endTime.substr(11, 5)}`
          }
        })
        this.appointmentOptions = list
      })
    },
    handleShow() {
      this.getAppointment()
      this.formVisible = true
    },
    handleSend(row) {
      this.$emit('created', row, 9)
      this.formVisible = false
    },
    handleCopy(item) {
      var input = document.createElement('input')
      input.value = item.orderNo;
      document.body.appendChild(input)
      input.select()
      document.execCommand('copy')
      document.body.removeChild(input)
      this.$message.success("复制成功");
    }
  }
}
</script>
<style lang="scss" scoped>
::v-deep .el-dialog__body {
  padding: 10px 0;
}
.cont-box {
  padding: 10px 20px;
  .list-box {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    .list {
      width: 48%;
      border: 1px solid #f3f3f3;
      border-radius: 6px;
      margin-bottom: 20px;
      .order-no {
        background: #f3f3f3;
        padding: 14px 15px;
        border-radius: 6px 6px 0 0;
        position: relative;
        .no {
          color: #1596cd;
          padding-right: 25px;
          padding-left: 10px;
        }
        .icon-rig {
          display: inline-block;
          float: right;
          em {
            font-style: normal;
            color: #999;
            &.red {
              color: #fe1a0d;
            }
            &.blue {
              color: #4680e3;
            }
          }
        }
      }
      .user {
        font-size: 16px;
        padding: 10px 0 0 15px;
      }
      .order-info {
        padding: 0 15px;
        div {
          font-size: 14px;

          padding-top: 10px;
          span {
            width: 70px;
            display: inline-block;
            color: #999;
          }
          p {
            display: inline-block;
            margin: 0;
            vertical-align: top;
            width: calc(100% - 90px);
            color: #000f29;
            &.yellow {
              color: #f3b71d;
            }
            &.gray {
              color: #999;
            }
          }
        }
      }
      .order-img {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 0 15px;
        .img-box {
          display: flex;
          overflow: hidden;
          overflow-x: auto;
          div {
            margin-right: 6px;
            img {
              width: 70px;
              height: 70px;
              border-radius: 10px;
            }
            p {
              width: 70px;
              margin: 0;
              font-size: 12px;
              color: #666;
              padding: 8px 0;
            }
          }
        }
        .amount {
          width: 85px;
          display: inline-block;
          font-size: 14px;
          color: #000f29;
          text-align: right;
          span {
            color: #999;
          }
        }
      }
      .send {
        padding: 10px 15px;
      }
    }
  }
}
.input-box {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 20px;
  .el-button {
    margin: 0 10px;
  }
}
.ipt-box {
  display: flex;
  align-items: center;
  margin-bottom: 18px;
  padding-right: 20px;
  i {
    font-size: 16px;
    cursor: pointer;
  }
}
::v-deep .el-icon-plus,
.el-icon-minus {
  margin-left: 4px;
  color: #60b7dc;
}
.ipt-box:last-child {
  margin-bottom: 0;
}

.dialog-footer {
  position: absolute;
  bottom: 5px;
  text-align: right;
  right: 20px;
}
::v-deep .date1 .el-input--prefix .el-input__inner {
  padding-left: 0;
}
/* 修改滚动条整体样式 */
::-webkit-scrollbar {
  width: 8px;
  height: 8px;
  /* 滚动条宽度 */
  background-color: #f1f1f1;
  /* 滚动条背景色 */
}

/* 修改滚动条滑块样式 */
::-webkit-scrollbar-thumb {
  background-color: #d2d2d2;
  /* 滑块颜色 */
  border-radius: 4px;
  /* 滑块圆角 */
}

/* 修改滚动条轨道样式 */
::-webkit-scrollbar-track {
  background-color: #f1f1f1;
  /* 轨道背景色 */
}

/* 修改滚动条角落样式 */
::-webkit-scrollbar-corner {
  background-color: #f1f1f1;
  /* 角落背景色 */
}
</style>
